import React from "react";

import ProviderNetworkSearchBanner from "../components/banner/ProviderNetworkSearchBanner";
import NetworkSearch from "../components/search/NetworkSearch";

function PreferredProviderSearch() {
  return (
    <>
      <ProviderNetworkSearchBanner />
      <NetworkSearch isProviderNetworkSearch={true} />
    </>
  );
}

export default PreferredProviderSearch;
